/**
 * File to hold all our bootstrap4-datetimepicker related JavaScript
 */

import 'pc-bootstrap4-datetimepicker';
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  // debug: true,
  icons: {
    time: 'material-icons mi-schedule',
    date: 'material-icons mi-calendar_today',
    up: 'material-icons mi-arrow_upward',
    down: 'material-icons mi-arrow_downward',
    previous: 'material-icons mi-navigate_before',
    next: 'material-icons mi-navigate_next',
    today: 'material-icons mi-event_available',
    clear: 'material-icons mi-delete_outline',
    close: 'material-icons mi-cancel'
  },
  locale: 'en-gb',
  format: 'YYYY-MM-DD',
});


$(function () {
  $('#dueDatetimepicker').datetimepicker({
    ignoreReadonly: true,
    allowInputToggle: true,
    useCurrent: false,
  });
});
